import React from 'react';
import TextArea from '../UI/TextArea';
import MultySelect from '../UI/MultiSelect';
import { useForm } from 'react-hook-form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ReactComponent as TooltipIcon } from '../../assets/icons/tooltip.svg';
import { SETASIDE_LIST, BUSINESS_TYPE_LIST } from '../../constans';

const FrameTwo = ({ onSubmit, onChangeHandler, handleMultiChange, inputValue, selectValue, list, onChange }) => {
  const { register, handleSubmit, errors } = useForm();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <fieldset>
        <label htmlFor="naics">NAICS codes for your business</label>
        <div className="tooltip-container-select">
          <MultySelect 
            onChangeHandler={onChangeHandler}
            handleMultiChange={handleMultiChange}
            name="naics"
            list={list}
            inputValue={inputValue.naics}
            selectValue={selectValue.filter(item => item.type === 'naics')}
            styles="react-select-container"
            prefixStyles="react-select"
            indicator={false}
            check={true}
          />
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="button-tooltip">
                Choose your NAICS (North American Industrial Classification System) code. If you are not familar with the right codes for the products or services you sell, review them at http://www.census.gov/eos/www/naics/
              </Tooltip>
            }
          >
            <TooltipIcon />
          </OverlayTrigger>
        </div>
      </fieldset>
      <fieldset>
        <label htmlFor="psc_code">PSC codes for your business</label>
        <div className="tooltip-container-select">
          <MultySelect 
            onChangeHandler={onChangeHandler}
            handleMultiChange={handleMultiChange}
            name="psc_code"
            list={list}
            inputValue={inputValue.psc_code}
            selectValue={selectValue.filter(item => item.type === 'psc_code')}
            styles="react-select-container"
            prefixStyles="react-select"
            indicator={false}
            check={true}
          />
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="button-tooltip">
                Choose your PSC code.
              </Tooltip>
            }
          >
            <TooltipIcon />
          </OverlayTrigger>
        </div>
      </fieldset>
      <fieldset>
        <label htmlFor="set_aside">Socio-Economic Type</label>
        <div className="tooltip-container-select">
          <MultySelect 
            onChangeHandler={onChangeHandler}
            handleMultiChange={handleMultiChange}
            name="set_aside"
            list={SETASIDE_LIST}
            inputValue={inputValue.set_aside}
            selectValue={selectValue.filter(item => item.type === 'set_aside')}
            styles="react-select-container"
            prefixStyles="react-select"
            indicator={false}
            check={true}
          />
           <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id="button-tooltip">
                  Select all that apply.
                </Tooltip>
              }
            >
              <TooltipIcon />
            </OverlayTrigger>
        </div>
      </fieldset>
      <fieldset>
        <label htmlFor="type">Industry</label>
        <div className="tooltip-container-select">
          <MultySelect 
            onChangeHandler={onChangeHandler}
            handleMultiChange={handleMultiChange}
            name="type"
            list={BUSINESS_TYPE_LIST}
            inputValue={inputValue.type}
            selectValue={selectValue.filter(item => item.type === 'type')}
            styles="react-select-container"
            prefixStyles="react-select"
            indicator={false}
            check={true}
          />
           <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id="button-tooltip">
                  Select all that apply.
                </Tooltip>
              }
            >
              <TooltipIcon />
            </OverlayTrigger>
        </div>
      </fieldset>
      <fieldset>
        <label htmlFor="description">Business Description <span>*</span></label>
        <div className="tooltip-container">
          <TextArea 
            name="description"
            register={register({ 
              required: true, 
              maxLength: {
                value: 600,
                message: "Up to 600 characters"
              }
            })}
          />
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="button-tooltip">
                There is a limit of 600 characters for this field.  Provide a short description of your business that contains the products or services you offer.
              </Tooltip>
            }
          >
            <TooltipIcon />
          </OverlayTrigger>
        </div>
        {errors.description && errors.description.type === "required" &&
          <p className="warnMessage">This field is required</p>
        }
        {errors.description && errors.description.type === "maxLength" && 
          <p className="warnMessage">Up to 600 characters</p>
        }
      </fieldset>
      <fieldset>
        <label htmlFor="business_keywords">Business Keywords</label>
        <div className="tooltip-container">
          <TextArea 
            name="keywords"
            value={inputValue.keywords}
            onChange={onChange}
            register={register({ 
              maxLength: {
                value: 600,
                message: "Up to 600 characters"
              }
            })}
          />
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="button-tooltip">
                Here you will type your keywords that relate to your business. There is a limit of 600 characters for this field. Please separate keywords with commas or commas with space for better matching.
              </Tooltip>
            }
          >
            <TooltipIcon />
          </OverlayTrigger>
        </div>
        {errors.keywords && errors.keywords.type === "maxLength" && 
          <p className="warnMessage">Up to 600 characters</p>
        }
      </fieldset>
      <button 
        type="submit"
        className="filledBtn btnSizes"
      >
        Save & Continue
      </button>
    </form>
  )
}

export default FrameTwo;